import { Component, Injector, OnInit, ViewChildren, HostListener } from '@angular/core';
import { NavParams, ModalController } from '@ionic/angular';
import { SettingService } from 'src/app/shared/services/setting.service';
import { NotificationBellServiceService } from 'src/app/store/services/notification-bell-service.service';
import { NotificationServiceService, INotifications } from 'src/app/store/services/notification-service.service';
import { AnalyticsService } from 'src/app/shared/services/analytics.service';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { IconService } from 'src/app/shared/services/icon.service';
import { Router } from '@angular/router';
@Component({
    selector: 'support-home-page',
    templateUrl: './support-home-page.component.html',
    styleUrls: ['./support-home-page.component.scss'],
    standalone: false
})
export class SupportHomePageComponent implements OnInit {
  title: string = 'Nav.Support';
  currentSegment: string = 'contact';

  valideNotification: number;
  AllNotifications: INotifications[];

  disableHeader: boolean = false;
  isPopup: boolean = false;

  mobile: boolean = false;

  bellIcon: IconDefinition;

  getCurrentPath(): string {
    return this.router.url;
  }
 
  constructor(
    public NotificationService: NotificationServiceService,
    public NotificationBellService: NotificationBellServiceService,
    public setting: SettingService,
    private injector: Injector,
    private modalCtrl: ModalController,
    private analytics: AnalyticsService,
    private iconService: IconService,
    private router: Router) { 
      this.bellIcon = this.iconService.getIcon('bell')!;
    }

  async ngOnInit() {
    try {
      this.valideNotification = await this.NotificationService.notificationCount();
      this.AllNotifications = this.NotificationService.notifationArray;
    } catch (e) {
      console.log("error collecting Notification Data");
    }

     // Only access NavParams if running inside a modal
     const navParams = this.injector.get(NavParams, null);
    try {
      if(navParams.get('disableHeader') != undefined) {
        this.disableHeader = navParams.get('disableHeader');
        this.isPopup = true;
      }
    } catch (e) {

    }

    if(!this.isPopup) {
      var currentUrl = this.getCurrentPath();
      localStorage.setItem('Stateurl', currentUrl);

    } else {
      localStorage.setItem('Stateurl', 'popup-contactus');
    }

    this.analytics.UpdateLocation({url: "/support", ispopup: this.isPopup},  true, false);

    if (window.innerWidth <= 500) {
      this.mobile = true;

      if(this.setting.configuration.uIoptions?.contactUsToPopup) {
        this.disableHeader = false;
      }
      
    } else {
      this.mobile = false;

      if(this.setting.configuration.uIoptions?.contactUsToPopup) {
        this.disableHeader = true;
      }
      
    }

    // temporarily. we'll need to set it up on the page soon
    (window as any).updateLoaderProgress(100);
    (window as any).finishAppShell?.();
  }


  @HostListener('window:resize', ['$event'])  
    onResize(event) { 
  
      if (window.innerWidth <= 500) { 
        this.mobile = true;

        if(this.setting.configuration.uIoptions?.contactUsToPopup) {
          this.disableHeader = false;
        }
        
      } else {
        this.mobile = false;

        if(this.setting.configuration.uIoptions?.contactUsToPopup) {
          this.disableHeader = true;
        }
        
      }
    }  

    closePopup(){
      if(this.isPopup) {
        this.modalCtrl.dismiss();
      }
    }
}
